import { useAppSelector } from "hooks/redux_hooks";
import { classroomSelectors } from "store";

function EmptyPane({ canModifyStage }: { canModifyStage: boolean }) {
  const isInPerson = useAppSelector(classroomSelectors.selectIsInPersonClass());

  return (
    <div
      className="bg-black-tint-10 text-black-tint-70 flex items-center justify-center w-full"
      style={{ border: "2px solid var(--black)" }}
      data-testid="empty-pane"
    >
      {canModifyStage && (
        <span className="p2 center">Drag to add {!isInPerson ? "a user or " : ""}a resource</span>
      )}
    </div>
  );
}

export { EmptyPane };
